import React from 'react'
import PropTypes from 'prop-types'
import { visuallyHidden } from '@mui/utils'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

// Same empty-cell dash as the coach Students list (`emptyValue` in
// student-item-view.js): a muted "--" for sighted users, with the reason
// available to screen readers.
const useStyles = makeStyles({
  emptyValue: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#C4C7C9',
  },
})

const EmptyValue = ({ label }) => {
  const classes = useStyles()
  return (
    <>
      <Typography className={classes.emptyValue} aria-hidden="true">
        --
      </Typography>
      <span style={visuallyHidden}>{label}</span>
    </>
  )
}

EmptyValue.propTypes = {
  label: PropTypes.string.isRequired,
}

export default EmptyValue
